import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import NewsDetailPage from './pages/NewsDetailPage'
import TopicDetailPage from './pages/TopicDetailPage'
import BoardMembersPage from './pages/BoardMembersPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import SitePolicyPage from './pages/SitePolicyPage'
import ContactPage from './pages/ContactPage'
import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/board" element={<BoardMembersPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/site-policy" element={<SitePolicyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/topic/:slug" element={<TopicDetailPage />} />
      </Routes>
    </Router>
  )
}

export default App

